import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { useUserRegion } from '../../hooks/useUserRegion';
import { CTAButton } from '../ui/CTAButton';
const BONUSES = [{
  num: 1,
  title: 'Pet Identifiers',
  desc: 'Learn to make personalized resin pet tags your clients will love. A high-demand, low-cost product perfect for Etsy.',
  value: '$27',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/j7b3zBVkp31NaENmFuPMat/PET_IDENTIFIERS.webp',
  imageAlt: 'Resin pet identifier tags in various colors',
  bullets: ['Easy molds', 'High margin', 'Ready to sell']
}, {
  num: 2,
  title: 'Decorative Resin Coasters',
  desc: 'Step-by-step guide to making professional coasters with stunning color effects and gold flakes. One of the best-selling resin products online.',
  value: '$27',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/aCKUM9fC6NMQWxCCaynnxV/DECORATIVE_RESIN_COASTEERS.jpg',
  imageAlt: 'Decorative resin coasters with colorful designs and gold flakes',
  bullets: ['Color techniques', 'Gold flakes', 'Bestseller product']
}, {
  num: 3,
  title: 'Irresistible Resin Phone Cases',
  desc: 'Create custom phone cases that sell for 3x the cost of materials. Includes mold selection, pigment ratios and finishing tips.',
  value: '$37',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/antYvfEfvUk6Pc9BT4Wz3Q/IRRESISTIBLE_RESIN_PHONE_CASE.webp',
  imageAlt: 'Custom resin phone cases with wood and color swirl designs',
  bullets: ['High demand', 'Custom designs', 'Fast to make']
}, {
  num: 4,
  title: 'Resin Jewelry',
  desc: 'Design and cast beautiful resin jewelry pieces — pendants, rings and earrings. Includes supplier list and pricing guide for Etsy.',
  value: '$47',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/7GniKjJzGrwfNZE4WQbddo/RESIN_JEWELRY.webp',
  imageAlt: 'Elegant resin jewelry with pressed flowers',
  bullets: ['Jewelry molds', 'Etsy-ready', 'Supplier list']
}, {
  num: 5,
  title: 'Decorative Boards in Resin',
  desc: 'Master the art of resin charcuterie boards — one of the most viral products on social media right now. Includes sizing, sealing and photography tips.',
  value: '$37',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/rTkCc3QVhAHREMshsc39Jb/DECORATIVE_BOARDS.webp',
  imageAlt: 'Decorative resin serving boards with marble patterns and gold handles',
  bullets: ['Viral product', 'Premium pricing', 'Photography tips']
}, {
  num: 6,
  title: 'Decorative Resin Organizers',
  desc: 'Turn everyday desk clutter into stunning rainbow glitter organizers people actually want to display — and buy. Learn to make matching sets that sell for $35–$80 and keep customers coming back for more.',
  value: '$27',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/ajNKj7rzRFDjrvodBgAn27/DECORATIVE_RESIN_ORGANIZARS.webp',
  imageAlt: 'Colorful decorative resin organizers with rainbow glitter',
  bullets: ['Glitter & color techniques', 'Matching sets', 'Home office niche'],
  imagePosition: 'center bottom' as const
}, {
  num: 7,
  title: 'Resin Candle Holders',
  desc: 'One of the most gifted products year-round. Master the molds, pigments and layering techniques that create glowing colorful holders — and price them for $25–$60 in the gift market.',
  value: '$27',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/pM5iotVFx3YjtU7r4bYqfU/hf_20260227_194754_5e286c95-d0b5-4dd9-8be5-64234dd9f334.webp',
  imageAlt: 'Resin Candle Holders — Complete Course & Exclusive Bonuses book with Top Seller badge',
  bullets: ['Gift market', 'Year-round sales', 'Easy to scale']
}, {
  num: 8,
  title: 'Personalized Resin Keychains',
  desc: 'Small size, huge margins. Letter and shape keychains with glitter and gold flakes are the #1 entry-level Etsy product. Learn to make them in batches and list them for $12–$25 each.',
  value: '$17',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/iQqF2u1cUdDaE1AczKuonE/PERSONALIZED_RESIN_KEYCHAINS.webp',
  imageAlt: 'Personalized resin keychains with glitter letters',
  bullets: ['Batch production', 'Gold flake technique', 'Best seller on Etsy']
}, {
  num: 9,
  title: 'Decorative Resin Trays',
  desc: 'Vibrant alcohol ink swirls, gold leaf details and brass handles — resin trays are a staple of the luxury home décor market. Learn the pour patterns that make buyers stop scrolling and click Buy Now.',
  value: '$27',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/qxyKQb5LQTWwBBwkhXK4Re/DECORATIVE_RESIN_TRAYS.webp',
  imageAlt: 'Colorful decorative resin trays with gold handles',
  bullets: ['Luxury niche', 'High ticket ($45–$120)', 'Gold leaf included']
}];
const BONUS_10 = {
  num: 10,
  title: "Resin Mugs — The Complete Seller's Kit",
  desc: 'The most complete bonus in the pack. Three full guides in one — everything you need to dominate the personalized mug niche from day one.',
  value: '$67',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/djrfhKuYAVxWbb5iE6HgZy/hf_20260227_190815_6037ffd0-746b-460d-9384-505c6124e89e.webp',
  imageAlt: 'Resin Mugs complete seller kit — Sales Guide, Advanced Techniques, and Supplier Rolodex books',
  bullets: ['Advanced Techniques', 'Sales Guide included', 'Supplier Rolodex'],
  subItems: [{
    title: 'Advanced Techniques',
    desc: 'Glitter gradients, color blending and heat timing for flawless mugs every time.'
  }, {
    title: 'Sales Guide',
    desc: 'Etsy & Shopify listings, keywords and pricing for $28–$55.'
  }, {
    title: 'Supplier List',
    desc: 'Vetted suppliers for blanks, sealers and packaging with fast shipping.'
  }]
};
export function Bonuses() {
  const {
    formattedPrice,
    loading
  } = useUserRegion();
  return <section className="w-full px-4 md:px-8 max-w-6xl mx-auto flex flex-col items-center" data-id="element-17">
      <FadeIn className="text-center mb-16" data-id="element-18">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-19">
          Exclusive Bonuses — Today Only
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-20">
          Order Today and Get These Exclusive Bonuses FREE
        </h2>
      </FadeIn>

      {/* Bonuses 1–9 Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full" data-id="element-21">
        {BONUSES.map((bonus, index) => <FadeIn key={index} delay={index * 100} direction="up" className="h-full" data-id="element-22">
            <div className="bg-darkCard border border-darkBorder rounded-2xl overflow-hidden h-full flex flex-col group hover:border-amber/30 transition-colors duration-300" data-id="element-23">
              <div className="w-full overflow-hidden" data-id="element-24">
                <img src={bonus.imageUrl} alt={bonus.imageAlt} className="w-full aspect-square object-cover border-b border-darkBorder group-hover:border-amber/30 transition-colors duration-300" style={(bonus as any).imagePosition ? {
              objectPosition: (bonus as any).imagePosition
            } : undefined} data-id="element-25" />
              </div>
              <div className="p-6 md:p-8 flex-1 flex flex-col" data-id="element-26">
                <span className="text-amber font-lato text-xs uppercase tracking-widest font-bold mb-3 block" data-id="element-27">
                  BONUS #{bonus.num}
                </span>
                <h3 className="font-playfair text-xl md:text-2xl text-cream mb-4" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="font-lato text-cream/70 leading-relaxed mb-4" data-id="element-29">
                  {bonus.desc}
                </p>

                <div className="flex flex-wrap gap-x-4 gap-y-1 mb-6 flex-1" data-id="element-30">
                  {bonus.bullets.map((bullet, i) => <span key={i} className="text-xs text-cream/40 font-lato" data-id="element-31">
                      <span className="text-amber/60" data-id="element-32">✓ </span>
                      {bullet}
                    </span>)}
                </div>

                <div className="pt-4 border-t border-darkBorder flex items-center justify-between mt-auto" data-id="element-33">
                  <span className="font-lato text-cream/50 line-through text-sm" data-id="element-34">
                    Value: {bonus.value}
                  </span>
                  <span className="font-playfair text-amber font-bold text-xl" data-id="element-35">
                    FREE
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>

      {/* Bonus #10 — Featured Card */}
      <FadeIn delay={1000} direction="up" className="w-full mt-8" data-id="element-36">
        <div className="bg-darkCard border-2 border-amber/50 rounded-2xl overflow-hidden flex flex-col group hover:border-amber/70 transition-colors duration-300 relative" data-id="element-37">
          {/* Premium badge */}
          <div className="absolute top-4 right-4 z-10 bg-amber text-dark px-3 py-1 rounded-full font-lato font-bold text-xs uppercase tracking-wider" data-id="element-38">
            Most Complete Bonus
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-39">
            <div className="w-full overflow-hidden" data-id="element-40">
              <img src={BONUS_10.imageUrl} alt={BONUS_10.imageAlt} className="w-full aspect-square object-cover" data-id="element-41" />
            </div>
            <div className="p-6 md:p-8 flex flex-col" data-id="element-42">
              <span className="text-amber font-lato text-xs uppercase tracking-widest font-bold mb-3 block" data-id="element-43">
                BONUS #{BONUS_10.num}
              </span>
              <h3 className="font-playfair text-xl md:text-2xl text-cream mb-4" data-id="element-44">
                {BONUS_10.title}
              </h3>
              <p className="font-lato text-cream/70 leading-relaxed mb-6" data-id="element-45">
                {BONUS_10.desc}
              </p>

              {/* Sub-items */}
              <div className="flex flex-col gap-4 mb-6 flex-1" data-id="element-46">
                {BONUS_10.subItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-47">
                    <span className="text-amber flex-shrink-0 mt-0.5" data-id="element-48">🔹</span>
                    <div data-id="element-49">
                      <span className="font-lato font-bold text-cream text-sm block" data-id="element-50">
                        {item.title}
                      </span>
                      <span className="font-lato text-cream/50 text-xs leading-relaxed" data-id="element-51">
                        {item.desc}
                      </span>
                    </div>
                  </div>)}
              </div>

              <div className="flex flex-wrap gap-x-4 gap-y-1 mb-6" data-id="element-52">
                {BONUS_10.bullets.map((bullet, i) => <span key={i} className="text-xs text-cream/40 font-lato" data-id="element-53">
                    <span className="text-amber/60" data-id="element-54">✓ </span>
                    {bullet}
                  </span>)}
              </div>

              <div className="pt-4 border-t border-amber/30 flex items-center justify-between mt-auto" data-id="element-55">
                <span className="font-lato text-cream/50 line-through text-sm" data-id="element-56">
                  Value: {BONUS_10.value}
                </span>
                <span className="font-playfair text-amber font-bold text-xl" data-id="element-57">
                  FREE
                </span>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>

      {/* Total Bonus Value Block */}
      <FadeIn delay={200} className="w-full mt-16 max-w-3xl" data-id="element-58">
        <div className="text-center mb-8" data-id="element-59">
          <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-60">
            Total Bonus Value
          </span>
          <p className="font-playfair text-3xl md:text-4xl text-cream" data-id="element-61">
            <span className="text-cream/40 line-through mr-3" data-id="element-62">$165+</span>
            Yours FREE Today
          </p>
        </div>
      </FadeIn>

      {/* Full Conversion Block */}
      <FadeIn delay={250} className="w-full mt-20 max-w-3xl" data-id="element-63">
        <div className="text-center flex flex-col items-center gap-8" data-id="element-64">
          <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold" data-id="element-65">
            You Get All of This Today for Just:
          </span>

          <div className="text-center" data-id="element-66">
            <p className="font-playfair text-6xl md:text-7xl text-cream font-bold mb-3" data-id="element-67">
              {loading ? <span className="w-28 h-16 bg-amber/20 rounded animate-pulse inline-block" data-id="element-68"></span> : formattedPrice}
            </p>
            <p className="font-lato text-cream/50 text-sm uppercase tracking-wider" data-id="element-69">
              One-time payment · No subscriptions · No hidden fees
            </p>
          </div>

          <a href="https://flawless-resin.shop/cart/43743823396952:1" target="_blank" rel="noopener noreferrer" className="
              w-full inline-flex items-center justify-center text-center
              bg-amber text-dark font-bold font-lato rounded-lg
              transition-all duration-300 ease-out
              hover:brightness-110 hover:scale-[1.02] active:scale-[0.98]
              glow-amber hover:glow-amber-lg
              px-8 md:px-10 py-5 text-lg md:text-xl
            " data-id="element-70">
            {loading ? <span className="flex items-center gap-2" data-id="element-71">
                Yes, I Want Instant Access + All 10 Bonuses —{' '}
                <span className="w-12 h-5 bg-dark/20 rounded animate-pulse inline-block" data-id="element-72"></span>{' '}
                »
              </span> : <span data-id="element-73">
                Yes, I Want Instant Access + All 10 Bonuses — {formattedPrice} »
              </span>}
          </a>

          <div className="flex flex-row items-center justify-center gap-4 md:gap-8 w-full" data-id="element-74">
            <div className="flex flex-col items-center text-center flex-1" data-id="element-75">
              <span className="text-xl md:text-2xl mb-1" aria-hidden="true" data-id="element-76">
                🔒
              </span>
              <span className="font-bold text-cream font-lato text-[11px] md:text-sm" data-id="element-77">
                Secure Checkout
              </span>
            </div>

            <div className="w-px h-8 bg-darkBorder flex-shrink-0" data-id="element-78"></div>

            <div className="flex flex-col items-center text-center flex-1" data-id="element-79">
              <span className="text-xl md:text-2xl mb-1" aria-hidden="true" data-id="element-80">
                ↩
              </span>
              <span className="font-bold text-cream font-lato text-[11px] md:text-sm" data-id="element-81">
                60-Day Guarantee
              </span>
            </div>

            <div className="w-px h-8 bg-darkBorder flex-shrink-0" data-id="element-82"></div>

            <div className="flex flex-col items-center text-center flex-1" data-id="element-83">
              <span className="text-xl md:text-2xl mb-1" aria-hidden="true" data-id="element-84">
                ⚡
              </span>
              <span className="font-bold text-cream font-lato text-[11px] md:text-sm" data-id="element-85">
                Instant Access
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}